import { Component, Renderer2, inject, DOCUMENT, effect, input, signal, untracked, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-profile-progress',
  imports: [
    MatIconModule
  ],
  templateUrl: './profile-progress.component.html',
  styleUrls: ['./profile-progress.component.scss']
})
export class ProfileProgressComponent {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly util = inject(UtilService);
  private readonly vars = inject(VariablesService);

  readonly dashArray = signal<number>(2 * Math.PI * 60);
  readonly dashOffset = signal<number>(this.dashArray());
  readonly animationStyle = signal<any>({ 'stroke-dashoffset': this.dashOffset });
  readonly percentage = input<number>(50);
  readonly userData = computed(() => this.vars.userData());
  readonly staticCircleCompleteValues = signal<any>({
    100: 120,
    70: 200,
    55: 300,
    60: 205,
    30: 422
  });
  readonly initials = signal('');

  constructor() {
    effect(() => {
      const p = this.percentage();
      untracked(() => {
        this.setProfileProgressBar();
      });
    });

    effect(() => {
      const user = this.userData();
      this.initials.set(this.util.getInitialsOfName(user?.full_name || '').toUpperCase());
    });
  }

  setProfileProgressBar() {
    if (this.percentage()) {
      let finalOffset = this.dashArray() * (1 - this.percentage() / 100);
      if (this.percentage() in this.staticCircleCompleteValues()) {
        finalOffset = this.staticCircleCompleteValues()[this.percentage()];
      }
      if (this.document?.head) {
        setTimeout(() => {
          this.dashOffset.set(finalOffset);
          this.addCustomAnimation(finalOffset);
        }, 0);
      }
    }
  }


  addCustomAnimation(offset: number) {
    const duration = '1s';  // You can change this to adjust the speed of the animation
    const easing = 'ease-in-out';  // Adjust the easing function if needed

    // Dynamically set the animation style string
    this.animationStyle.set(`anim ${duration} ${easing} forwards`);
    const styleSheet = this.renderer.createElement('style');
    styleSheet.type = 'text/css';
    const keyframes = `
      @keyframes anim {
        100% {
          stroke-dashoffset: ${offset};
        }
      }
    `;
    styleSheet.innerHTML = keyframes;
    this.renderer.appendChild(this.document.head, styleSheet);
  }
}
